import React from 'react'

import classNames from 'classnames'

import { getValidProps } from 'hsds/utils/react'

import {
  BodyUI,
  ButtonUI,
  ConfirmationBodyUI,
  ConfirmationFooterUI,
  ConfirmationHeadingUI,
  ConfirmationWrapperUI,
  FooterUI,
  HeaderFooterContainerScrollUI,
  HeaderUI,
} from './SimpleModal.layouts.styles'

import type {
  ConfirmationProps,
  HeaderAndFooterProps,
} from './SimpleModal.types'

const noop = () => {}

export function HeaderAndFooter({
  children,
  heading,
  header,
  footer,
  ...rest
}: HeaderAndFooterProps): JSX.Element {
  return (
    <HeaderFooterContainerScrollUI
      className="SimpleModal__ContainerScroll"
      {...getValidProps(rest)}
    >
      <HeaderUI
        className={classNames(
          'SimpleModal__header',
          header && 'with-custom-header-content'
        )}
      >
        {header ? header : <h1>{heading}</h1>}
      </HeaderUI>
      <BodyUI className="SimpleModal__body">{children}</BodyUI>
      {footer && <FooterUI className="SimpleModal__footer">{footer}</FooterUI>}
    </HeaderFooterContainerScrollUI>
  )
}

export function Confirmation({
  heading,
  body,
  onConfirm = noop,
  onCancel = noop,
  confirmButtonProps = {},
  cancelButtonProps = {},
  confirmButtonText = 'Accept',
  cancelButtonText = 'Cancel',
  danger,
}: ConfirmationProps): JSX.Element {
  return (
    <ConfirmationWrapperUI className={classNames(!body && 'is-compact')}>
      <ConfirmationHeadingUI>{heading}</ConfirmationHeadingUI>
      {body && <ConfirmationBodyUI>{body}</ConfirmationBodyUI>}
      <ConfirmationFooterUI>
        <ButtonUI
          className="Confirmation_CancelButton"
          outlined={!danger}
          color={danger ? 'blue' : 'grey'}
          onClick={onCancel}
          size="lg"
          {...cancelButtonProps}
        >
          {cancelButtonText}
        </ButtonUI>
        <ButtonUI
          className="Confirmation_ConfirmButton"
          color={danger ? 'red' : 'blue'}
          outlined={danger}
          onClick={onConfirm}
          size="lg"
          {...confirmButtonProps}
        >
          {confirmButtonText}
        </ButtonUI>
      </ConfirmationFooterUI>
    </ConfirmationWrapperUI>
  )
}
